import { render } from "./Info.vue?vue&type=template&id=0c826eb4"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__